const triggerUpdateWriteReviewFields = () => {
    var updateWriteReviewFields = setInterval(function() {
        if ($('#pr-war-form').length) {
            clearInterval(updateWriteReviewFields);
            $('#pr-war-form .form-group').hide();
            $('#pr-war-form .form-group #pr-headline, #pr-rating, #pr-comments, #pr-name, #pr-location, #pr-email_collection, #pr-size').parent().show();
            $('#pr-war-form .form-group #pr-headline, #pr-rating, #pr-comments, #pr-name, #pr-location, #pr-email_collection, #pr-size').parent().children().show();
            $('.pr-headline-form-group').hide();
        }
    }, 1500);
};

export {triggerUpdateWriteReviewFields}
